import { createTheme } from '@mui/material/styles';

const brand = {
  primary: '#B8894A',
  primaryDark: '#8F6A35',
  primaryLight: '#D4A574',
  accent: '#F7EFE3',
};

export function createAppTheme(mode = 'light') {
  const isDark = mode === 'dark';

  return createTheme({
    direction: 'rtl',
    palette: {
      mode,
      primary: {
        main: brand.primary,
        dark: brand.primaryDark,
        light: brand.primaryLight,
        contrastText: '#fff',
      },
      secondary: {
        main: brand.primaryLight,
        contrastText: '#fff',
      },
      background: {
        // Transparent so PharmacyBackground shows through page shells
        default: 'transparent',
        paper: isDark ? '#1e1e1e' : '#ffffff',
      },
      text: {
        primary: isDark ? '#f5f5f5' : '#2C2416',
        secondary: isDark ? '#B5A890' : '#7A6B55',
      },
      divider: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(184,137,74,0.12)',
    },
    typography: {
      fontFamily: "'NRT', sans-serif",
      h4: { fontWeight: 800, fontSize: '2.125rem' },
      h5: { fontWeight: 700, fontSize: '1.625rem' },
      h6: { fontWeight: 700, fontSize: '1.3rem' },
      subtitle1: { fontSize: '1.05rem', lineHeight: 1.55 },
      subtitle2: { fontSize: '0.95rem', lineHeight: 1.5 },
      body1: { fontSize: '1.05rem', lineHeight: 1.65 },
      body2: { fontSize: '0.9375rem', lineHeight: 1.55 },
      button: { textTransform: 'none', fontWeight: 700, fontSize: '0.9375rem' },
    },
    shape: { borderRadius: 14 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            fontSize: '16px',
            '@media (min-width:900px)': {
              fontSize: '17.5px',
            },
          },
          body: {
            scrollbarColor: `${brand.primary} transparent`,
            overflowX: 'hidden',
            overscrollBehaviorY: 'none',
            WebkitOverflowScrolling: 'touch',
            touchAction: 'pan-y',
          },
          '#root': {
            minHeight: '100%',
            isolation: 'isolate',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: isDark
              ? '0 4px 20px rgba(0,0,0,0.4)'
              : '0 4px 20px rgba(184,137,74,0.1)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            background: `linear-gradient(90deg, ${brand.primaryLight}, ${brand.primary})`,
          },
        },
      },
    },
  });
}

export { brand };
